__webpack_require__.p = "/developers/mitzael_serna/mtg/";